(() => {
  'use strict';
  // Use the same recorded pieces as the selected ready-stock variant. Never infer a set from its title or photo.
  function readySetGroups(variant, includes, dimensions, ar) {
    const pieces = variant?.pieces;
    if (!Array.isArray(pieces) || !pieces.length || pieces.some(p => !['sofa', 'chair'].includes(p.type) || !(p.width > 0) || !(p.depth > 0) || !(p.seats > 0))) return [];
    const groups = new Map();
    pieces.forEach(p => {
      const type = p.type === 'chair' ? 'armchair' : 'sofa_' + p.seats;
      const key = [type, p.width, p.depth].join(':');
      if (groups.has(key)) { groups.get(key).qty++; return; }
      const fact = includes.find(x => x.piece === type && Number(x.dims?.w) === Number(p.width) && Number(x.dims?.d) === Number(p.depth));
      const dim = dimensions.find(x => x.piece === type);
      const names = {1: 'كنبة مفردة', 2: 'كنبة ثنائية', 3: 'كنبة ثلاثية', 4: 'كنبة رباعية', 5: 'كنبة خماسية'};
      const name = p.type === 'chair' ? (ar ? 'كرسي مفرد' : 'Armchair') : (ar ? names[p.seats] || 'كنبة ' + p.seats + ' مقاعد' : p.seats + '-seat sofa');
      groups.set(key, {type, name, qty: 1, seats: Number(p.seats), w: Number(p.width), d: Number(p.depth), h: Number(fact?.dims?.h) || null, estimated: !!dim?.h_estimated});
    });
    return [...groups.values()];
  }
  function syncReadySetDetails(profile, variant, ar) {
    if (profile.kind !== 'set') return;
    const section = document.getElementById('KpeSize-' + profile.id);
    if (!section || section.dataset.readySetVariant === String(variant.id)) return;
    let includes, dimensions;
    try { includes = JSON.parse(section.dataset.readySetIncludes); dimensions = JSON.parse(section.dataset.readySetDimensions).pieces; } catch { return; }
    if (!Array.isArray(includes) || !Array.isArray(dimensions)) return;
    const groups = readySetGroups(variant, includes, dimensions, ar);
    if (!groups.length) return;
    const count = groups.reduce((n, g) => n + g.qty * g.seats, 0);
    const seats = ar ? count + (count <= 10 ? ' مقاعد' : ' مقعدًا') : count + ' seats';
    const description = groups.map(g => g.qty + ' × ' + g.name).join(' + ');
    const heading = document.querySelector('[data-ready-set-facts="' + profile.id + '"] span');
    if (heading) heading.textContent = seats + ' · ' + description;
    const title = section.querySelector('.kps-h3');
    if (title) title.textContent = (ar ? 'يشمل الطقم · ' : 'In this set · ') + seats;
    const table = section.querySelector('.kps-table');
    const tbody = table?.querySelector('tbody');
    const anyHeight = groups.some(g => g.h);
    if (tbody) {
      const rows = groups.map(g => {
        const row = document.createElement('tr');
        const name = document.createElement('th'); name.scope = 'row'; name.textContent = g.name;
        const qty = document.createElement('td'); qty.textContent = String(g.qty);
        const size = document.createElement('td');
        size.textContent = [Math.round(g.w), Math.round(g.d)].concat(anyHeight ? [g.h ? (g.estimated ? '≈' : '') + Math.round(g.h) : '–'] : []).join(' × ');
        row.append(name, qty, size); return row;
      });
      tbody.replaceChildren(...rows);
      const label = table.querySelector('thead th:last-child');
      if (label) label.textContent = ar ? (anyHeight ? 'العرض × العمق × الارتفاع (سم)' : 'العرض × العمق (سم)') : (anyHeight ? 'W × D × H (cm)' : 'W × D (cm)');
      const note = section.querySelector('.kps-note');
      if (note) note.hidden = !groups.some(g => g.h && g.estimated);
    }
    const cm = ar ? 'سم' : 'cm';
    const maxDepth = Math.max(...groups.map(g => g.d));
    const totalWidth = groups.reduce((n, g) => n + g.w, 0) + (groups.length - 1) * 24;
    const scale = Math.min(500 / totalWidth, 240 / maxDepth);
    const height = Math.ceil(44 + maxDepth * scale + 48);
    let x = (600 - totalWidth * scale) / 2 + 12;
    let svg = '';
    groups.forEach(g => {
      const w = g.w * scale, d = g.d * scale, y = 44 + (maxDepth - g.d) * scale;
      const arm = Math.min(d * .2, w * .12), back = d * .24, cx = x + w / 2;
      svg += `<rect class="kz-o" x="${x}" y="${y}" width="${w}" height="${d}" rx="6"/><rect class="kz-b" x="${x}" y="${y}" width="${w}" height="${back}" rx="6"/><rect class="kz-b" x="${x}" y="${y}" width="${arm}" height="${d}" rx="6"/><rect class="kz-b" x="${x + w - arm}" y="${y}" width="${arm}" height="${d}" rx="6"/>`;
      for (let n = 1; n < g.seats; n++) svg += `<path class="kz-l" d="M${x + arm + (w - 2 * arm) * n / g.seats} ${y + back}V${y + d}"/>`;
      svg += `<text class="kz-t" x="${cx}" y="${44 + maxDepth * scale + 32}" text-anchor="middle">${Math.round(g.w)} ${cm}</text>`;
      if (g.qty > 1) svg += `<text class="kz-t kz-q" x="${cx}" y="${y - 12}" text-anchor="middle">×${g.qty}</text>`;
      x += w + 24 * scale;
    });
    const dx = (600 - totalWidth * scale) / 2 - 6, bottom = 44 + groups[0].d * scale;
    svg += `<path class="kz-d" d="M${dx} 44V${bottom}M${dx - 5} 44h10M${dx - 5} ${bottom}h10"/><text class="kz-t" transform="translate(${dx - 12} ${(44 + bottom) / 2}) rotate(-90)" text-anchor="middle">${Math.round(groups[0].d)} ${cm}</text>`;
    document.querySelectorAll('[data-ready-set-drawing="' + profile.id + '"]').forEach(drawing => {
      const slide = drawing.dataset.readySetView === 'slide';
      drawing.setAttribute('viewBox', '0 0 600 ' + (slide ? 450 : height));
      drawing.setAttribute('aria-label', (ar ? 'رسم المقاسات للطقم المختار: ' : 'Selected set dimensions: ') + seats + '. ' + groups.map(g => g.qty + ' × ' + g.name + ' ' + g.w + ' × ' + g.d + ' ' + cm).join(', '));
      // Numeric geometry above; the label uses text/attributes. No external HTML is inserted.
      drawing.innerHTML = slide ? `<g transform="translate(0 ${(450 - height) / 2})">${svg}</g>` : svg;
    });
    const caption = section.querySelector('.kps-fig figcaption');
    if (caption) caption.textContent = (ar ? 'منظر علوي بمقياس رسم للطقم المختار · ' : 'Top view, to scale, of the selected set · ') + seats;
    const largest = groups.reduce((a, b) => b.w * b.d > a.w * a.d ? b : a);
    const fit = section.querySelector('.kps-fit strong');
    if (fit) fit.textContent = (ar ? 'أكبر قطعة: ' : 'Largest piece: ') + largest.name + ', ' + largest.w + ' × ' + largest.d + ' ' + cm + '.';
    section.dataset.readySetVariant = String(variant.id);
  }

  // §1.13 "size chips are selectors" (v3 fix, 2026-10-22): a ready product with more than one stocked size shows its
  // sizes as chips right above Add to cart. The fabric lock still hides the Edit buttons (no studio detour), so the chips
  // are the size control. A chip only changes the variant: klikReady.setOptions → the stock quote, the buy-box total
  // (Add to cart and the sticky bar mirror it), the "Size & pieces" row and the variant that addNow() adds.
  function mountSizes(dialog, profile, t, ar) {
    const api = dialog.klikReady;
    const variants = (profile.variants || []).filter(v => v && v.id);
    if (variants.length < 2 || !api?.setOptions || dialog.dataset.readySizesBound) return;
    dialog.dataset.readySizesBound = 'true';
    // Arabic grammar: 11–99 take the singular (11 مقعدًا), as the store's variant titles do; the profile data reads
    // "11 مقاعد", which the Size & pieces row, the studio and the cart line would print. Display names only.
    if (ar) variants.forEach(v => { const m = /^(\d+) مقاعد$/.exec(v.names?.ar || ''); if (m && Number(m[1]) >= 11) v.names.ar = m[1] + ' مقعدًا'; });
    const pictured = String(variants[0].id);
    const asShownText = t('Price as shown', 'السعر كما في الصورة'), priceText = t('Price', 'السعر');
    const selector = '.ready-sizes[data-ready-sizes="' + profile.id + '"]';
    // ready-stock.liquid prints the chips (template) and places them when the buy box appears; this file binds them.
    const template = document.querySelector('template[data-ready-sizes-template="' + profile.id + '"]');
    const seats = n => ar ? (n === 1 ? 'مقعد واحد' : n === 2 ? 'مقعدان' : n <= 10 ? n + ' مقاعد' : n + ' مقعدًا') : n + (n === 1 ? ' seat' : ' seats');
    const label = v => Number.isInteger(v.seats) && v.seats > 0 ? seats(v.seats) : typeof v.names === 'object' && v.names ? (ar ? v.names.ar : v.names.en) || v.names.en || '' : String(v.name || v.title || '');
    const describe = v => { try { return String(window.KlikReadySetChoices?.description?.(v, ar) || ''); } catch { return ''; } };
    const money = cents => {
      const offer = window.KlikPricePresentation?.price?.(cents), shown = offer ? offer.current : cents;
      if (window.KlikMoney?.node) return window.KlikMoney.node(shown, { mode: 'browse' });
      return document.createTextNode(window.KlikPricePresentation?.format ? window.KlikPricePresentation.format(shown) : (shown / 100).toLocaleString('en-US') + t(' SAR', ' ريال'));
    };
    const el = (tag, cls, text) => { const node = document.createElement(tag); node.className = cls; if (text) node.textContent = text; return node; };
    // Fallback when the Liquid template is missing (an older cached section): the same markup, built here.
    function build() {
      const box = el('div', 'ready-sizes');
      box.dataset.readySizes = String(profile.id);
      box.setAttribute('data-wg-notranslate', '');
      const head = el('p', 'ready-sizes__label', profile.kind === 'set' ? t('Set size', 'حجم الطقم') : t('Size', 'المقاس'));
      head.id = 'ready-sizes-' + profile.id;
      const row = el('div', 'ready-sizes__row');
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-labelledby', head.id);
      variants.forEach(v => {
        const chip = el('button', 'ready-size');
        chip.type = 'button';
        chip.setAttribute('role', 'radio');
        chip.dataset.variantId = String(v.id);
        const dot = el('span', 'ready-size__dot');
        dot.setAttribute('aria-hidden', 'true');
        const text = el('span', 'ready-size__text');
        const price = el('span', 'ready-size__price');
        price.append(money(v.priceCents));
        text.append(el('strong', 'ready-size__name', label(v)), price);
        chip.append(dot, text);
        if (v.available === false) chip.disabled = true;
        row.append(chip);
      });
      const note = el('p', 'ready-sizes__note');
      note.setAttribute('aria-live', 'polite');
      box.append(head, row, note, el('p', 'ready-sizes__fabric'));
      return box;
    }
    const current = () => String(api.getSnapshot().variantId);
    let group = null, chips = [], note = null, fabric = null, busy = false;
    // The fabric that is added (locked ready pages: the one in the photos), without the internal SKU code.
    const fabricText = () => { try { const name = String(api.summary?.().fabricLabel || '').replace(/\s+[A-Z]{1,4}-[\d-]+(?=\s*(?:\/|·|,|$))/g, '').trim(); return name ? t('Fabric: ', 'القماش: ') + name : ''; } catch { return ''; } };
    function paint(message) {
      if (!group) return;
      const id = current();
      chips.forEach(chip => {
        const on = chip.dataset.variantId === id;
        if (chip.getAttribute('aria-checked') !== String(on)) chip.setAttribute('aria-checked', String(on));
        chip.tabIndex = on ? 0 : -1;
      });
      const v = variants.find(item => String(item.id) === id);
      const photoNote = profile.kind === 'set' && id !== pictured ? t(' Photos show ', ' الصور تعرض طقم ') + label(variants[0]) + t('; the size diagram shows your selection.', '؛ رسم المقاسات يعرض اختيارك.') : '';
      const text = message || (v ? describe(v) + photoNote : '');
      if (v) syncReadySetDetails(profile, v, ar);
      if (note && note.textContent !== text) note.textContent = text;
      const cloth = fabricText();
      if (fabric && fabric.textContent !== cloth) fabric.textContent = cloth;
      paintLabel();
    }
    // "Price as shown" only for the photographed size. Only these two states are ours; the studio's own labels
    // ("Your configuration") stay untouched.
    function paintLabel() {
      const lab = group?.closest('.kp6-purchase')?.querySelector('.kp6-price-label');
      const want = current() === pictured ? asShownText : priceText;
      if (lab && lab.textContent.trim() !== want && [asShownText, priceText].includes(lab.textContent.trim())) lab.textContent = want;
    }
    function paintPrice() {
      const total = group?.closest('.kp6-purchase')?.querySelector('.kp6-total');
      const snap = api.getSnapshot(), quote = snap.quote, v = variants.find(item => String(item.id) === String(snap.variantId));
      if (!total || !v || !window.KlikPricePresentation?.render) return;
      const quantity = Number.isInteger(snap.quantity) && snap.quantity > 0 ? snap.quantity : 1;
      const valid = quote && !snap.quoteError && quote.canAdd === true && String(quote.variantId) === String(v.id) &&
        quote.quantity === quantity && Number.isSafeInteger(quote.unitPriceCents) && quote.unitPriceCents > 0;
      const unit = valid ? quote.unitPriceCents : v.priceCents;
      if (!Number.isSafeInteger(unit) || unit <= 0) return;
      window.KlikPricePresentation.render(total, unit * quantity, { compact: total.dataset.kpriceCompact === 'true', mode: total.dataset.kpriceMode === 'exact' ? 'exact' : undefined, quantity, lines: [{ unit, quantity }] });
      total.dataset.amount = String(unit * quantity / 100);
    }
    async function choose(v) {
      const id = String(v.id);
      if (busy || id === current() || api.journey?.busy?.()) return;
      busy = true;
      group.setAttribute('aria-busy', 'true');
      chips.forEach(chip => chip.setAttribute('aria-checked', String(chip.dataset.variantId === id)));
      let message = '';
      try {
        await api.setOptions({ variantId: v.id });
        if (current() !== id) throw new Error('unchanged');
        paintPrice();
        try { const next = new URL(location.href); next.searchParams.set('variant', id); history.replaceState(history.state, '', next); } catch {}
        window.KlikOptimal?.track?.('klik_ready_size_selected', { product_id: profile.id, variant_id: id });
      } catch {
        message = t('Please try again.', 'حاول مجددًا.');
      } finally {
        busy = false;
        group.removeAttribute('aria-busy');
        paint(message);
      }
    }
    function onKey(event) {
      const keys = { ArrowRight: ar ? -1 : 1, ArrowLeft: ar ? 1 : -1, ArrowDown: 1, ArrowUp: -1 };
      const live = chips.filter(chip => !chip.disabled);
      const at = live.indexOf(document.activeElement);
      if (at < 0) return;
      let next = -1;
      if (event.key in keys) next = (at + keys[event.key] + live.length) % live.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = live.length - 1;
      if (next < 0) return;
      event.preventDefault();
      live[next].focus();
      live[next].click();
    }
    function bind(box) {
      group = box;
      note = box.querySelector('.ready-sizes__note');
      fabric = box.querySelector('.ready-sizes__fabric');
      chips = [...box.querySelectorAll('.ready-size[data-variant-id]')];
      chips.forEach(chip => {
        const v = variants.find(item => String(item.id) === chip.dataset.variantId);
        if (v) chip.addEventListener('click', () => choose(v));
        else chip.disabled = true;
      });
      box.querySelector('[role=radiogroup]')?.addEventListener('keydown', onKey);
      // The shared buy box may print its label after this (e.g. a ?variant= landing on the 11-seat set): re-check it.
      const lab = box.closest('.kp6-purchase')?.querySelector('.kp6-price-label');
      if (lab) new MutationObserver(paintLabel).observe(lab, { childList: true, characterData: true, subtree: true });
      paint();
    }
    // The buy box (.kflow) is built by the shared product page after load: use the chips already placed, or place them.
    const place = () => {
      const actions = (document.querySelector('[data-kpd-page]') || document).querySelector('section.kflow > .kflow-actions') || document.querySelector('section.kflow > .kflow-actions');
      if (!actions) return false;
      let box = document.querySelector(selector);
      if (!box) {
        box = template?.content.firstElementChild ? template.content.firstElementChild.cloneNode(true) : build();
        actions.before(box);
      }
      if (box !== group) bind(box);
      return true;
    };
    if (!place()) {
      const watch = new MutationObserver(() => place() && watch.disconnect());
      watch.observe(document.querySelector('[data-kpd-page]') || document.body, { childList: true, subtree: true });
      setTimeout(() => watch.disconnect(), 20000);
    }
    // A size picked inside the studio, or the variant from the URL, keeps the chips in step.
    document.addEventListener('klik:hazel-config', event => { if (String(event.detail?.productId) === String(profile.id) && group?.isConnected) paint(); });
  }
  // Owner 2026-10-23 ("ready to ship sofas: the top 5 most common colours", "use global data"): a ready product offers the
  // fabric in the photos plus five colours (snippets/klik-ready-swatches). They show here as swatches above the size chips;
  // a tap only changes the fabric (klikReady.setOptions → the studio state, the 3D, the cart line). Same price, same delivery.
  function mountColours(dialog, profile, t, ar) {
    const api = dialog.klikReady;
    if (!api?.setOptions || !api.materials?.list || dialog.dataset.readyFabricLock === 'true' || dialog.dataset.readyColoursBound) return;
    const list = () => { try { return (api.materials.list() || []).filter(f => f && f.id != null); } catch { return []; } };
    if (list().length < 2) return;
    dialog.dataset.readyColoursBound = 'true';
    const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text) node.textContent = text; return node; };
    const WORD = { gray: ['Grey', 'رمادي'], grey: ['Grey', 'رمادي'], offwhite: ['Off-white', 'أوف وايت'], cream: ['Cream', 'كريمي'], beige: ['Beige', 'بيج'], green: ['Green', 'أخضر'], blue: ['Blue', 'أزرق'], teal: ['Teal', 'بترولي'], taupe: ['Taupe', 'بني رمادي'], brown: ['Brown', 'بني'], khaki: ['Khaki', 'زيتي'] };
    // owner 2026-10-23: the fabric type is named too (from the name: type words, known ranges, W/R)
    const KINDS = [[/chenille|شانيل|شنيل/i,['Chenille','شانيل']],[/velvet|مخمل|krizia|كريزيا|verna|فيرنا/i,['Velvet','مخمل']],[/boucl|بوكليه|بوكلي/i,['Bouclé','بوكليه']],[/jacquard|جاكار|venture|فينتشر/i,['Jacquard','جاكار']],[/linen|كتان/i,['Linen','كتان']],[/cotton|قطن/i,['Cotton','قطن']],[/leather|جلد/i,['Faux leather','جلد صناعي']],[/tweed|تويد/i,['Tweed','تويد']],[/woven|نسيج|منسوج/i,['Woven','منسوج']]];
    const typeOf = f => {
      const s = [f.type, f.texture, f.names?.en, f.names?.ar, f.name].filter(Boolean).join(' ');
      const k = KINDS.find(([rx]) => rx.test(s));
      if (!k) return '';
      const base = ar ? k[1][1] : k[1][0];
      if (/w\/r\b|water.?resist|مقاوم للماء/i.test(s)) return ar ? base + ' مقاوم للماء' : 'Water-resistant ' + base.toLowerCase();
      if (/\be\/c\b|easy.?clean|سهل التنظيف/i.test(s)) return ar ? base + ' سهل التنظيف' : 'Easy-clean ' + base.toLowerCase();
      return base;
    };
    const colourOf = f => {
      const en = String(f.names?.en || f.name || '').split('·')[0].trim();
      const w = WORD[en.toLowerCase().replace(/[^a-z]/g, '')];
      if (w) return ar ? w[1] : w[0];
      const a = String(f.names?.ar || '').split('·')[0].trim();
      return ar && a ? a : en;
    };
    const current = () => { try { return String(api.getSnapshot().fabric); } catch { return ''; } };
    let box = null, chips = [], label = null, busy = false;
    function paint() {
      if (!box) return;
      const id = current();
      chips.forEach(c => { const on = c.dataset.fabricId === id; c.setAttribute('aria-checked', String(on)); c.tabIndex = on ? 0 : -1; });
      const f = list().find(x => String(x.id) === id);
      if (label && f) label.textContent = (f.original ? t('As pictured', 'كما في الصورة') : colourOf(f)) + (typeOf(f) ? ' · ' + typeOf(f) : '');
    }
    async function choose(id) {
      if (busy || id === current() || api.journey?.busy?.()) return;
      busy = true; box.setAttribute('aria-busy', 'true');
      chips.forEach(c => c.setAttribute('aria-checked', String(c.dataset.fabricId === id)));
      try { await api.setOptions({ fabricId: id }); window.KlikOptimal?.track?.('klik_ready_colour_selected', { product_id: profile.id, fabric_id: id }); }
      catch { /* the studio keeps its state; paint() shows the real one */ }
      finally { busy = false; box.removeAttribute('aria-busy'); paint(); }
    }
    function build() {
      const b = el('div', 'ready-colours');
      b.dataset.readyColours = String(profile.id);
      b.setAttribute('data-wg-notranslate', '');
      const head = el('p', 'ready-colours__label');
      head.id = 'ready-colours-' + profile.id;
      head.append(document.createTextNode(t('Colour: ', 'اللون: ')));
      label = el('span', 'ready-colours__current');
      head.append(label);
      const row = el('div', 'ready-colours__row');
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-labelledby', head.id);
      const items = list();
      const pic = items.find(f => f.original) || items[0];
      const order = String(dialog.dataset.readySwatches || '').toLowerCase().split('|').filter(Boolean);
      const rank = f => { const i = order.indexOf(String(f.sku || '').toLowerCase()); return i < 0 ? order.indexOf(String(f.id).toLowerCase()) : i; };
      [pic].concat(items.filter(f => f !== pic && !f.photoChoice).sort((x, y) => (rank(x) < 0 ? 99 : rank(x)) - (rank(y) < 0 ? 99 : rank(y)))).forEach(f => {
        const c = el('button', 'ready-colour');
        c.type = 'button';
        c.setAttribute('role', 'radio');
        c.dataset.fabricId = String(f.id);
        const sw = el('span', 'ready-colour__sw');
        sw.setAttribute('aria-hidden', 'true');
        const img = f.image || f.textureUrl || '';
        if (img && !f.original) sw.style.backgroundImage = 'url("' + String(img).replace(/"/g, '%22') + '")';
        sw.style.backgroundColor = f.color || '#d9d1c4';
        if (f.original && img) sw.style.backgroundImage = 'url("' + String(img).replace(/"/g, '%22') + '")';
        const name = f.original ? t('As pictured', 'كما في الصورة') : colourOf(f);
        const kind = typeOf(f);
        c.append(sw, el('span', 'ready-colour__name', name));
        if (kind) c.append(el('span', 'ready-colour__type', kind));
        c.setAttribute('aria-label', kind ? name + ' · ' + kind : name);
        c.addEventListener('click', () => choose(String(f.id)));
        row.append(c);
      });
      row.addEventListener('keydown', event => {
        const keys = { ArrowRight: ar ? -1 : 1, ArrowLeft: ar ? 1 : -1, ArrowDown: 1, ArrowUp: -1 };
        const at = chips.indexOf(document.activeElement);
        if (at < 0 || !(event.key in keys)) return;
        event.preventDefault();
        const next = chips[(at + keys[event.key] + chips.length) % chips.length];
        next.focus(); next.click();
      });
      const note = el('p', 'ready-colours__note', t('Same price · ready to ship in 1–7 business days', 'السعر نفسه · جاهز للتوصيل خلال \u20661–7\u2069 أيام عمل'));
      const go = el('button', 'ready-colours__3d');
      go.type = 'button';
      go.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/></svg>';
      go.append(el('span', '', t('See it in 3D in your colour', 'شاهده بتقنية 3D باللون الذي تختاره')));
      go.addEventListener('click', () => {
        const open = [...document.querySelectorAll('[data-ready-open="' + profile.id + '"]')].find(x => !x.hasAttribute('data-ready-quick')) || document.querySelector('[data-ready-open]:not([data-ready-quick])');
        if (open) open.click();
        try { window.KlikOptimal?.track?.('klik_ready_colour_3d', { product_id: profile.id }); } catch {}
      });
      b.append(head, row, note, go);
      return b;
    }
    const place = () => {
      const scope = document.querySelector('[data-kpd-page]') || document;
      const actions = scope.querySelector('section.kflow > .kflow-actions') || document.querySelector('section.kflow > .kflow-actions');
      if (!actions) return false;
      if (!box || !box.isConnected) {
        box = document.querySelector('.ready-colours[data-ready-colours="' + profile.id + '"]') || build();
        const sizes = document.querySelector('.ready-sizes[data-ready-sizes="' + profile.id + '"]');
        (sizes || actions).before(box);
        chips = [...box.querySelectorAll('.ready-colour[data-fabric-id]')];
      }
      paint();
      return true;
    };
    if (!place()) {
      const watch = new MutationObserver(() => place() && watch.disconnect());
      watch.observe(document.querySelector('[data-kpd-page]') || document.body, { childList: true, subtree: true });
      setTimeout(() => watch.disconnect(), 20000);
    }
    // The size chips mount after this and insert before Add to cart: keep the colours first.
    setTimeout(place, 600);
    document.addEventListener('klik:hazel-config', event => { if (String(event.detail?.productId) === String(profile.id)) paint(); });
    dialog.addEventListener('close', paint);
  }
  function mount() {
    document.querySelectorAll('[data-ready-quick]').forEach(button => {
      if (button.dataset.quickBound) return;
      const dialog = document.querySelector('[data-ready-configurator][data-product-id="'+button.dataset.readyQuick+'"]');
      const profile = window.KlikReadyProfiles?.[button.dataset.readyQuick];
      if (!dialog?.klikReady || !profile) return;
      button.dataset.quickBound = 'true';
      const ar = document.documentElement.lang.startsWith('ar');
      const t = (en,arabic) => ar ? arabic : en;
      const text = value => typeof value === 'string' ? value : value?.[ar?'ar':'en'] || value?.en || '';
      const name = item => text(item.names || item.name || item.title);
      const productSection = button.closest('[data-section-type="product"]');
      let pagePrice, pagePriceKey = '', pageSelection;
      function syncPagePrice() {
        if (!productSection?.isConnected || productSection.dataset.productId !== String(profile.id)) return;
        // Ready stock uses its own Liquid price block, not the generic data-product-price markup.
        const currentPrice = productSection.querySelector('.ready-page-price > .product__price') || productSection.querySelector('.product-block--price [data-product-price]');
        if (!currentPrice) return;
        if (currentPrice !== pagePrice) {
          pagePrice = currentPrice;
          pagePriceKey = '';
          if (pageSelection && !productSection.contains(pageSelection)) pageSelection.remove();
          pageSelection = productSection.querySelector('[data-ready-page-selection]');
        }
        const state = dialog.klikReady.getSnapshot(), quote = state.quote;
        const selected = profile.variants.find(item => String(item.id) === String(state.variantId));
        if (!selected) return;
        const quantity = state.quantity;
        const valid = !state.quoteError && quote?.canAdd === true &&
          String(quote.productId) === String(profile.id) && String(quote.variantId) === String(state.variantId) &&
          Number.isInteger(quantity) && quantity >= 1 && quantity <= 6 && quote.quantity === quantity &&
          Number.isSafeInteger(quote.unitPriceCents) && quote.unitPriceCents > 0 &&
          quote.totalPriceCents === quote.unitPriceCents * quantity;
        const formatter = window.theme?.Currency?.formatMoney;
        const moneyFormat = window.theme?.settings?.moneyFormat;
        const phase = state.quoteError ? 'error' : !quote ? 'pending' : !valid ? 'unavailable' : typeof formatter === 'function' && moneyFormat ? 'priced' : 'review';
        const key = JSON.stringify([state.variantId, quantity, phase, quote?.unitPriceCents, quote?.currency, moneyFormat]);
        if (key === pagePriceKey) return;
        pagePriceKey = key;
        if (!pageSelection) {
          pageSelection = document.createElement('p');
          pageSelection.className = 'ready-buy-summary__note';
          pageSelection.dataset.readyPageSelection = '';
          pageSelection.setAttribute('aria-live', 'polite');
          pageSelection.setAttribute('data-wg-notranslate', '');
          pagePrice.insertAdjacentElement('afterend', pageSelection);
        }
        const basis = profile.kind === 'set' ? t('Price per set', 'السعر للطقم الواحد') : t('Price per piece', 'السعر للقطعة الواحدة');
        pageSelection.textContent = name(selected) + ' · ' + basis + (quantity > 1 ? ' · ' + t('Quantity: ', 'الكمية: ') + quantity : '');
        pagePrice.setAttribute('aria-busy', String(phase === 'pending'));
        // The server price (klik-offer-price → klik-money) stays when the quote agrees with it; otherwise one formatter.
        const serverBase = Number(pagePrice.querySelector('[data-kprice-base]')?.dataset.kpriceBase);
        if (phase === 'priced' && serverBase === quote.unitPriceCents) { /* already right, campaign-aware */ }
        else if (phase === 'priced') pagePrice.innerHTML = window.KlikMoney?.format ? window.KlikMoney.format(quote.unitPriceCents, { mode: 'browse' }) : formatter(quote.unitPriceCents, moneyFormat);
        else pagePrice.textContent = phase === 'pending' ? t('Updating price…', 'جارٍ تحديث السعر…') : phase === 'unavailable' ? t('Review availability in options', 'راجع التوفر ضمن الخيارات') : t('Review price in options', 'راجع السعر ضمن الخيارات');
        // The stock quote does not verify a compare-at price; never retain a crossed-out price for another set.
        productSection.querySelector('[data-product-price-wrap]')?.classList.add('hide');
        pagePrice.classList.remove('sale-price');
        productSection.querySelector('[data-compare-price-a11y]')?.setAttribute('aria-hidden', 'true');
        productSection.querySelector('[data-a11y-price]')?.setAttribute('aria-hidden', 'true');
      }
      document.addEventListener('klik:hazel-config', event => {
        if (String(event.detail?.productId) === String(profile.id)) syncPagePrice();
      });
      button.textContent=t('Review the current selection','راجع الاختيار الحالي');
      // §1.13 / K-099: one direct Add to cart. The shared buy box calls this adapter (KlikOrderAsShown, bugs-pdp-shared);
      // it adds the selection on screen (default size, the fabric in the photos) without opening the studio.
      const adapter = {
        summary: () => {
          const st = dialog.klikReady.summary?.() || {};
          return { title: st.title || dialog.dataset.productTitle, pieces: [], sizeLabel: st.sizeLabel || '', fabricLabel: st.fabricLabel || '', priceCents: st.priceCents };
        },
        add: () => dialog.klikReady.addNow ? dialog.klikReady.addNow().then(result => result || Promise.reject(new Error('busy'))) : Promise.reject(new Error('unavailable'))
      };
      mountSizes(dialog, profile, t, ar);
      mountColours(dialog, profile, t, ar);
      const register = () => window.KlikOrderAsShown?.register?.(profile.id, adapter);
      register();
      if (!window.KlikOrderAsShown) { document.addEventListener('DOMContentLoaded', register, { once: true }); window.addEventListener('load', register, { once: true }); }
      document.querySelectorAll('[data-ready-add="' + profile.id + '"]').forEach(add => {
        if (add.dataset.readyAddBound) return;
        add.dataset.readyAddBound = 'true';
        add.addEventListener('click', () => {
          if (add.getAttribute('aria-busy') === 'true') return;
          const label = add.textContent;
          add.setAttribute('aria-busy', 'true');
          add.textContent = t('Adding…', 'جارٍ الإضافة…');
          adapter.add()
            .then(result => window.KlikCartAdded ? window.KlikCartAdded(result, { family: 'ready', productId: profile.id, handle: location.pathname.split('/products/')[1]?.split(/[/?#]/)[0] || '' }) : location.assign('/cart'))
            .catch(() => { const st = add.parentElement?.querySelector('[data-ready-add-status]'); if (st) st.textContent = t('Please try again.', 'حاول مجددًا.'); })
            .finally(() => { add.removeAttribute('aria-busy'); add.textContent = label; });
        });
      });
      button.onclick=()=>dialog.klikReady.open({quick:true});
      dialog.addEventListener('close',syncPagePrice);
      // A native quote can settle before the progressive enhancement mounts.
      const initial = dialog.klikReady.getSnapshot();
      if (initial.quote || initial.quoteError) syncPagePrice();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
